import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { stripHtml } from "core/utils/string";
import { useProxyPageOverride } from "arena/components/ProxyPage/ProxyPageOverrideContext";

export default function ProductHelmet({ product }) {
  const override = useProxyPageOverride();
  const image = product?.preview?.url;
  const title = override?.title || product.title;
  const description =
    override?.description ||
    (product.description ? stripHtml(product.description) : null);

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="twitter:title" content={title} />
      <meta property="og:title" content={title} />

      {description && <meta name="description" content={description} />}

      {description && <meta property="og:description" content={description} />}

      {description && <meta name="twitter:description" content={description} />}

      {override?.keywords && (
        <meta name="keywords" content={override.keywords} />
      )}

      <meta name="twitter:card" content="summary_large_image" />
      {image && <meta property="og:image" content={image} />}
      {image && <link rel="image_src" href={image} />}
      {image && <meta name="twitter:image" content={image} />}
      {image && <meta property="vk:image" content={image} />}

      {override?.canonicalUrl && (
        <link rel="canonical" href={override.canonicalUrl} />
      )}
    </Helmet>
  );
}

ProductHelmet.propTypes = {
  product: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    shareUrl: PropTypes.string.isRequired,
    preview: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
};
